import { IonSelect } from "@ionic/react";
import { SelectInterface, SelectChangeEventDetail } from '@ionic/core/dist/types/interface'
import React from "react";

interface SelectProps
{
    interface: SelectInterface,
    value: any | null,
    disabled?: boolean,
    className?: string,
    onIonChange: (event: CustomEvent<SelectChangeEventDetail>) => void
};

const SelectNoCache: React.FC<SelectProps> = (props) => {

    return (
        <IonSelect className={props.className} name={Math.random().toString()} interface={props.interface} value={props.value} disabled={props.disabled} onIonChange={props.onIonChange}>
            {props.children}
        </IonSelect>
    );
};

export default SelectNoCache;